import { DataSource, Label, Layout, SearchButton, Table, Textbox} from "@mcleod/components";

export abstract class AutogenLayoutTablePaymentsReceived extends Layout {
	labelDaysOfChecks: Label;
	searchbuttonSearch: SearchButton;
	sourcePaymentsReceived: DataSource;
	tablePaymentsReceived: Table;
	textboxDaysofChecks: Textbox;
}
